<ngx-pull-to-refresh
   spinnerColor="#ff0000"
   [spinnerSize]="50"
   [distanceForRefresh]="40"
   [isEnable]="true"
   [targetElement]="targetElement"
   (refresh)="myRefreshEvent($event, 'refresh')"
   >

  <nav class="navbar home navbar-expand-lg navbar-light" *ngIf="!showSidebar && admin.isAdmin()">
    <div class="container-fluid">
      <a *ngIf="!showSidebar" routerLink="/" class="logo-width">
        <img *ngIf="ThemeService.getThemes() == 'light'" src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp" class="logo"/>
        <img *ngIf="ThemeService.getThemes() == 'dark'" src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp" class="logo"/>
        <img *ngIf="ThemeService.getThemes() === 'system'" 
        [src]="isSystemDark ? 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp' : 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp'" 
        class="logo"/>
      </a>

      <app-profile class="user"></app-profile>



    </div>
  </nav> 

  <div id="main" [ngClass]="{'shifted': isOpen && showSidebar, 'backdrop': isOpen && showSidebar}" *ngIf="admin.isAdmin()" (click)="closeSidebar($event)">
    

    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">

        <a class="menu" (click)="toggleNav($event)" *ngIf="showSidebar">
          <i class="fi fi-rr-bars-staggered"></i>
        </a>

        <a *ngIf="!showSidebar" routerLink="/" class="logo-width">
          <img *ngIf="ThemeService.getThemes() == 'light'"  src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp" class="logo"/>
          <img *ngIf="ThemeService.getThemes() == 'dark'" src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp" class="logo"/>
          <img *ngIf="ThemeService.getThemes() === 'system'" 
          [src]="isSystemDark ? 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp' : 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp'" 
          class="logo"/>
        </a>

        <app-profile class="user"></app-profile>

      </div>
    </nav> 

    <!-- ვერიფიკაცია -->
    <ng-template #verifyModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">ელ.ფოსტის ვერიფიკაცია</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <p class="text-danger">თქვენი ელ.ფოსტა: {{email}} არ არის ვერიფიცირებული </p>
        <app-seand [email]="email"></app-seand>

      </div>
    </ng-template>
    <div #scrollContainer style="height: 100vh; overflow-y: auto;">
    <router-outlet></router-outlet>
    </div>

  </div>

  <div class="container-fluid" *ngIf="!admin.isAdmin()">
    <router-outlet></router-outlet>
  </div>

  <div class="sidebar" [ngClass]="{'open': isOpen}" *ngIf="admin.isAdmin() && showSidebar">
    <!-- <a routerLink="/">
      <img *ngIf="ThemeService.getThemes() == 'light'"  src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp" class="logo-sidebar ps-4"/>
      <img *ngIf="ThemeService.getThemes() == 'dark'" src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp" class="logo-sidebar ps-4"/>
      <img *ngIf="ThemeService.getThemes() === 'system'" 
      [src]="isSystemDark ? 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo-dark.webp' : 'https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp'" 
      class="logo-sidebar ps-4"/>
    </a> -->

    <div class="list-group list-group-flush  ps-4">
      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-house-chimney"></i>
          <span class="mx-1">მთავარი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/app/analitic', id]" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-chart-histogram"></i>
          <span class="mx-1">ანალიტიკა</span>
      </a>

      <a 
        class="list-group-item" 
        [routerLink]="['/app/orders', id]" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-order-history"></i>
          <span class="mx-1"> {{ 'ORDERS' | translate }} </span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/app/products', id]" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-hamburger-soda"></i>
          <span class="mx-1"> {{ 'DISHES' | translate }}</span>

      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/app/setting', id]" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-settings"></i>
          <span class="mx-1"> {{ 'SETTING' | translate }}</span>
      </a>

    </div>
  </div>

</ngx-pull-to-refresh>

<app-navigacion *ngIf="showSidebar" [id]="id" class="menu-sm"></app-navigacion>

<!-- <app-footer></app-footer> -->





